
import {
  defineComponent,
  PropType,
  ref,
  computed,
} from 'vue';
import { useI18n } from 'vue-i18n';
// import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { ShopsSendDomains } from '@/types/generated-types/graphql';
import { /* ValidateDomainByEmail, */ VerifyDomain } from '@/composables/shop/ShopsSendDomains';
import { showToastSuccess } from '@/helpers';
// import { UserState } from '@/composables/User';

export default defineComponent({
  name: 'DomainOwnershipValidation',

  components: {
    // InputText,
    Button,
  },

  props: {
    domain: {
      type: Object as PropType<ShopsSendDomains>,
      required: true,
    },
  },

  emits: ['validated'],

  setup(props, { emit }) {
    const { t } = useI18n();
    // Email validation désactivée temporairement — décommenter avec la
     // section template correspondante pour réactiver.
    const activeTab = ref<'email' | 'dns'>('dns');
    // const localPart = ref('');
    // const sendingEmail = ref(false);
    // const emailSent = ref(false);
    // const emailError = ref('');
    const verifyingDns = ref(false);
    const dnsError = ref('');

    const dnsRecordValue = computed(
      () => `shopimind-verification-key=${props.domain.dns_verification_key ?? ''}`,
    );

    // Email validation désactivée temporairement — décommenter pour réactiver.
    /*
    const handleSendEmail = async () => {
      const trimmed = localPart.value.trim();
      if (!trimmed) {
        return;
      }

      emailError.value = '';
      sendingEmail.value = true;
      try {
        const idShop = UserState.activeShop?.id ?? 0;
        const idDomain = Number(props.domain.id_domain ?? 0);
        const response = await ValidateDomainByEmail(idShop, idDomain, trimmed);

        if (response && (response as any).success) {
          emailSent.value = true;
          await showToastSuccess(t('shop.my_domains.ownership_validation.email.sent', {
            email: `${trimmed}@${props.domain.domain}`,
          }));
        } else {
          emailError.value = t('shop.my_domains.ownership_validation.email.errorSendFailed');
        }
      } catch (err) {
        emailError.value = t('shop.my_domains.ownership_validation.email.errorSendFailed');
      } finally {
        sendingEmail.value = false;
      }
    };
    */

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(dnsRecordValue.value);
        await showToastSuccess(t('copiedToClipboard'));
      } catch (err) {
        // ignore
      }
    };

    const handleVerifyDns = async () => {
      dnsError.value = '';
      verifyingDns.value = true;
      try {
        const idDomain = Number(props.domain.id_domain ?? 0);
        const { data, err } = await VerifyDomain(idDomain);

        if (err || !data) {
          dnsError.value = t('shop.my_domains.ownership_validation.dns.errorGeneric');
          return;
        }

        const raw = data.domain_verified as unknown;
        const verified = raw === true || raw === 1 || raw === '1';
        if (verified) {
          await showToastSuccess(t('shop.my_domains.ownership_validation.successMessage'));
          emit('validated', data);
        } else {
          dnsError.value = t('shop.my_domains.ownership_validation.dns.errorNotFound');
        }
      } catch (err) {
        dnsError.value = t('shop.my_domains.ownership_validation.dns.errorGeneric');
      } finally {
        verifyingDns.value = false;
      }
    };

    return {
      t,
      activeTab,
      // localPart,
      // sendingEmail,
      // emailSent,
      // emailError,
      verifyingDns,
      dnsError,
      dnsRecordValue,
      // handleSendEmail,
      handleCopy,
      handleVerifyDns,
    };
  },
});
